import { pushData } from '@nykaa/data-layer/utils';
import { DefaultTranslations } from '@nykaa/review-card-shared/types';
import { CAV_ACTION, CAB_ACTION } from 'shared/constants';
import { CUSTOMERS_ALSO_BOUGHT, CUSTOMERS_ALSO_VIEWED } from 'constants/productPage';
import { requiredStrings } from 'constants/reviews';
import { ListingProduct } from 'store/categoryListing/types';
import { RecommendationObj } from 'store/variants/types';


interface DetailObj {
  [key: string]: number
}
interface Messages {
  [key: string]: string;
}

interface PLPTrackingOptions {
  prefix?: string;
  shouldReturn?: boolean;
  sumString?: string;
}

const isValid = (obj = {}) => {
  const isValidObj = typeof obj === 'object' && !Array.isArray(obj) && obj !== null;
  if (!isValidObj) {
    return null;
  };
};

const jointStrings = (obj:{[key:string]:string} = {}, prefix?: string) => {
  const hasPrefix = prefix ? `${prefix}_` : '';
  let res = '';
  for (let key in obj) {
    res += `${hasPrefix}${key}:${obj[key]};`;
  };
  return res;
};

export const getSum = (details:DetailObj = {}) => {
  let values = Object.values(details);
  let sum = 0;

  for (let idx = 0; idx < values.length; idx += 1) {
    const ele = values[idx];

    if (typeof ele !== 'number') {
      continue;
    }

    sum = sum + ele;
  }

  return sum;
 };

export const coverageCalc = (details:DetailObj = {}) => {
  const coverage: DetailObj = {};
  let sum = 0;
  let keys = Object.keys(details);

  if (!keys) {
    return {};
  }

  sum = getSum(details);

  for (let idx = 0; idx < keys.length; idx += 1) {
    const eleKey = keys[idx];
    const ele = details[eleKey];

    if (typeof ele !== 'number') {
      continue;
    }

    let calc: number = (ele / sum);
    coverage[eleKey] = Number(calc.toFixed(2));
  }
  return { coverage, sum };
};

export const objToStr = (obj: DetailObj, options = {} ) => {
  const {
    prefix,
    sumString,
    sum,
  } = options;
  isValid(obj);
  let res = '';
  res = jointStrings(obj, prefix);
  if (sum) {
    res += `${sumString || 'sum'}:${sum}`;
  }
  return res;
};

export const plpFiltersAndSortingToString = (obj: DetailObj, sum: number, prefix: string = '') => {
  isValid(obj);
  let res = '';
  for (let key in obj) {
    res += `${prefix}${key}:${obj[key]};`;
  };
  if (sum) {
    res += `${prefix}total:${sum};`;
  }
  return res;
};

export const getReviewTranslations = (messages: Messages, defaultMessages: Messages): DefaultTranslations => {
  const result: DefaultTranslations = {};
  requiredStrings.forEach((key: string) => {
    const value = messages[key] || defaultMessages[key];
    if (value) {
      result[key] = value;
    }
  });
  const YOU = messages['REVIEW_YOU'] || defaultMessages['REVIEW_YOU'];
  result.YOU = YOU;
  return result;
};

export const plpContentTracking = (products: ListingProduct[]|RecommendationObj[] = [], options: PLPTrackingOptions = {}) => {
  const { prefix = '', shouldReturn = false, sumString = false } = options;
  let details: {[key: string]: number} = {};
  products?.forEach((prod) => {
    const { contentLang } = (prod as ListingProduct);
    if (contentLang) {
      const { name } = contentLang;
      details[name] = details[name] ? details[name] += 1 : 1;
    }
  });
  if (Object.keys(details).length) {
    const { coverage = {}, sum = 0 } = coverageCalc(details);
    const prefixOptions = {
      prefix,
      sumString,
      sum,
    };
    const strFromObj = objToStr(coverage, prefixOptions);
    if (!shouldReturn) {
      pushData({ plpContent: strFromObj });
    } else {
      return strFromObj;
    }
  }
};

export const getCustomID = (value: string) => {
  if (typeof value !== 'string') {
    throw new Error('Please provide string as parameter');
  }
  let customID = value?.toUpperCase();
  customID = customID?.trim();
  customID = customID?.replace(/[\W_]+/g, '_');
  return customID;
};

export const getClickSource = (title: string, isAction = false) => {
  if (title === CUSTOMERS_ALSO_VIEWED) {
    return `${CAV_ACTION}${ isAction ? 'Action' : ''}`;
  } else if (title === CUSTOMERS_ALSO_BOUGHT) {
    return `${CAB_ACTION}${ isAction ? 'Action' : ''}`;
  }
  return title;
};

export const recommendationShortForm = (title: string) => {
  switch (title) {
    case CUSTOMERS_ALSO_VIEWED: return 'CAV';
    case CUSTOMERS_ALSO_BOUGHT: return 'CAB';
    default: return title;
  }
};
